let pageConfig = {};

// 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '订单管理'
    },
    {
        type: 'title',
        name: '活动订单列表'
    },
    {
        type: 'title',
        name: '家充无忧服务订单列表'
    }
];

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '订单管理',
    },
    {
        type: 'router',
        name: '家充无忧服务订单列表',
        router: 'activityOrderZreoList'
    },
    {
        type: 'title',
        name: '活动订单编辑'
    }
];


export default pageConfig;
